module.exports = __webpack_public_path__ + "_assets/img/profile-03.c4c86134.svg";